import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  Button,
  Skeleton,
} from 'antd';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { EnvironmentTwoTone } from '@ant-design/icons';
import moment from 'moment';
import { GlobalApiErrorHandler, MetaMaker } from '../../shared/helpers';
import { MsgBox } from '../../shared/custom-ant-d'
import { AppStatus } from '../../constants/AppStatus';
import { reqGetRetrieveJobDetails } from '../../axios/api'

export const JobItem = (props) => {
  const Auth = useSelector(state => state.Auth);
  const AppliedJobs = useSelector(state => state.AppliedJobs);
  const JobsUrl = useSelector(state => state.JobsUrl);
  const history = useHistory();
  const [jobDetails, setJobDetails] = useState(null);
  const [location, setLocation] = useState("");

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();
  const { id, title } = useParams();


  useEffect(() => {

    if (id) {
      getJobDetails(id);
    } else {
      MsgBox({
        type: 'error',
        message: 'Error',
        description: 'No selected job.',
      });

      //return history.push('/jobs');
      setTimeout(() => {
        window.location.href = JobsUrl + "/jobs";
      }, 2000);
    }
  }, [JobsUrl]);

  const getJobDetails = (jobPostingID) => {
    reqGetRetrieveJobDetails(jobPostingID)
      .then(res => {
        setJobDetails(res.data);
        setLocation(res.data.jobPostingCity + ", " + ((res.data.jobPostingStateName) ? res.data.jobPostingStateName + ", " : "") + res.data.jobPostingCountryName);
      })
      .catch(err => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  }

  const onClickApply = (e) => {
    e.preventDefault();

    if (!Auth.isLoggedIn) {
      MsgBox({
        type: 'error',
        message: 'Authentication Error',
        description: 'You must login first to apply.',
      });

      return history.push({
        pathname: '/login',
        state: {
          prevPath: "/job-apply",
          search: "?jobPostingID=" + jobDetails.jobPostingID,
          jobDetails: jobDetails
        }
      });
    }

    if (AppliedJobs) {
      let isInAppliedJobs = AppliedJobs.filter((item) => {
        return (jobDetails.jobPostingID === item.jobPostingID) && item.appStatus !== AppStatus.Withdrawn;
      });
      console.log(isInAppliedJobs);
      if (isInAppliedJobs.length > 0) {
        return MsgBox({
          type: 'error',
          message: 'Error',
          description: "You have already applied to this job."
        });
      }
    }

    return history.push({
      pathname: '/job-apply',
      search: "?jobPostingID=" + jobDetails.jobPostingID,
      state: {
        jobDetails: jobDetails
      },
    });
  }

  return (
    <>
      {jobDetails && <MetaMaker descriptionJob={jobDetails.jobTitleName} descriptionLocation={location} pageTitle={jobDetails.jobTitleName + " | " + location} />}

      <Row style={{ marginBottom: "10px" }}>
        <Col xs={24}>
          <Button type="default" htmlType="button" onClick={e => {
            e.preventDefault();
            window.location.href = JobsUrl + "/jobs";
          }}>
            Go Back To List
          </Button>
        </Col>
      </Row>

      <Row justify="center">
        <Col md={23} xs={24}>
          {
            (jobDetails) ? (
              <>
                <Card title={jobDetails.jobTitleName} className="iqor-header">

                  <Button type="danger" style={{ width: "100%" }} htmlType="button" onClick={e => onClickApply(e)}>
                    Apply Now
                  </Button>

                  <div className="job-details">
                    <p>
                      <strong>Location: </strong><EnvironmentTwoTone className="inline-icon" twoToneColor="#52c41a" /> {" "}
                      {location}
                    </p>

                    <p>
                      <strong>Posted Date: </strong> {moment(jobDetails.startDt).format('MM/DD/YYYY')}
                    </p>
                  </div>

                  <div className="job-header" dangerouslySetInnerHTML={{ __html: jobDetails.jobHeader }} />

                  <div className="job-description" dangerouslySetInnerHTML={{ __html: jobDetails.jobDescription }} />

                  <div className="job-footer" dangerouslySetInnerHTML={{ __html: jobDetails.jobFooter }} />

                  <Button type="danger" style={{ width: "100%" }} htmlType="button" onClick={e => onClickApply(e)}>
                    Apply Now
                  </Button>
                </Card>
              </>
            ) : (<Skeleton active />)
          }
        </Col>
      </Row>
    </>
  );
}
